import { Col, Form, Row, Input, Select } from "antd";
import { GET_USERS_ROLE_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const UsersFilterFields = ({ initialTableData }) => {
  const [options, setOptions] = useState({
    roles: [],
  });

  const fetchRoleTypes = useCallback(async (filterValues) => {
    const bodyData = {
      // per_page: 3,
      app_menu: "yes",
      ...filterValues,
    };
    const query = `${GET_USERS_ROLE_ENDPOINT}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      return response.data?.data?.data?.map((role) => ({
        ...role,
        value: role.id,
        label: role.name,
      }));
    } else {
      return [];
    }
  }, []);

  const getOptionsList = async () => {
    const role = await fetchRoleTypes();
    setOptions((prev) => ({
      ...prev,

      roles: role,
    }));
  };

  useEffect(() => {
    getOptionsList();
  }, []);

  const onSearchRole = async (values) => {
    const role = await fetchRoleTypes({ name: values });

    setOptions((prev) => ({
      ...prev,
      roles: role,
    }));
  };

  return (
    <>
      <Col span={4}>
        <Form.Item label="Name" name="name">
          <Input placeholder="Name" size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Email" name="email">
          <Input placeholder="Email" size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Id Card No" name="id_card_no">
          <Input placeholder="Id Card No" size="small" />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label="Role" name="role_id">
          <Select
            placeholder="Select Role"
            options={options?.roles}
            allowClear
            showSearch
            filterOption={false}
            onSearch={onSearchRole}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default UsersFilterFields;
